import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7df7d282"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "staff-schedule" }
const _hoisted_2 = { class: "staff-toolbar" }
const _hoisted_3 = { class: "staff-picker" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "lich-nhan-vien" }, "Nhân viên cần xem", -1))
const _hoisted_5 = {
  key: 0,
  class: "staff-note"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Chưa có nhân viên trong bản chia giờ này.")
const _hoisted_7 = { class: "staff-detail-heading" }
const _hoisted_8 = { class: "clock-cell" }
const _hoisted_9 = { class: "clock-cell" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Nhân viên chưa được xếp dịch vụ trong bản lưu này.")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_Dropdown, {
          inputId: "lich-nhan-vien",
          modelValue: _ctx.selectedId,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedId) = $event)),
          options: _ctx.summary,
          optionValue: "nhanVienId",
          optionLabel: "tenNhanVien",
          placeholder: "Tất cả nhân viên",
          filter: true,
          showClear: true
        }, null, 8, ["modelValue", "options"])
      ]),
      _createVNode(_component_Button, {
        label: _ctx.selectedId!=null ? 'Excel nhân viên đang xem' : 'Excel tất cả nhân viên',
        icon: "pi pi-file-excel",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.xuat())),
        loading: _ctx.exporting,
        disabled: _ctx.exporting || !_ctx.ketQua.lichSuId || !_ctx.summary.length
      }, null, 8, ["label", "loading", "disabled"])
    ]),
    (!_ctx.ketQua.nhanViens?.length && _ctx.ketQua.tongNhanVienCoMat>_ctx.summary.length)
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Bản lưu cũ chỉ có thông tin những nhân viên đã được xếp dịch vụ."))
      : _createCommentVNode("", true),
    (_ctx.selectedId==null)
      ? (_openBlock(), _createBlock(_component_DataTable, {
          key: 1,
          value: _ctx.summary,
          paginator: "",
          rows: 10,
          rowsPerPageOptions: [10,25,50],
          stripedRows: "",
          showGridlines: "",
          tableStyle: {minWidth:'750px'}
        }, {
          empty: _withCtx(() => [
            _hoisted_6
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              field: "tenNhanVien",
              header: "Nhân viên",
              sortable: ""
            }),
            _createVNode(_component_Column, {
              field: "tongDichVu",
              header: "Dịch vụ",
              sortable: ""
            }),
            _createVNode(_component_Column, {
              field: "soChinh",
              header: "Chính"
            }),
            _createVNode(_component_Column, {
              field: "soPhu",
              header: "Phụ"
            }),
            _createVNode(_component_Column, {
              field: "tongPhut",
              header: "Phút làm",
              sortable: ""
            }),
            _createVNode(_component_Column, {
              field: "sang",
              header: "Sáng"
            }),
            _createVNode(_component_Column, {
              field: "chieu",
              header: "Chiều"
            }),
            _createVNode(_component_Column, { header: "Chi tiết" }, {
              body: _withCtx((row) => [
                _createVNode(_component_Button, {
                  label: "Xem lịch",
                  class: "p-button-text",
                  onClick: ($event: any) => (_ctx.selectedId=row.data.nhanVienId)
                }, null, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("p", null, [
              _createElementVNode("strong", null, _toDisplayString(_ctx.selected?.tenNhanVien), 1),
              _createTextVNode(" · " + _toDisplayString(_ctx.selected?.tongDichVu || 0) + " dịch vụ · " + _toDisplayString(_ctx.selected?.tongPhut || 0) + " phút · Chính: " + _toDisplayString(_ctx.selected?.soChinh || 0) + " · Phụ: " + _toDisplayString(_ctx.selected?.soPhu || 0), 1)
            ]),
            _createVNode(_component_Button, {
              label: "Về danh sách nhân viên",
              icon: "pi pi-arrow-left",
              class: "p-button-text",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedId=null))
            })
          ]),
          _createVNode(_component_DataTable, {
            key: _ctx.selectedId,
            value: _ctx.details,
            paginator: "",
            rows: 10,
            rowsPerPageOptions: [10,25,50],
            stripedRows: "",
            showGridlines: "",
            tableStyle: {minWidth:'1080px'}
          }, {
            empty: _withCtx(() => [
              _hoisted_10
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Column, { header: "Buổi" }, {
                body: _withCtx((row) => [
                  _createTextVNode(_toDisplayString(row.data.lich.thoiGianBatDau.slice(11,13) < '12' ? 'Sáng' : 'Chiều'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Bắt đầu" }, {
                body: _withCtx((row) => [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.hour(row.data.lich.thoiGianBatDau)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, { header: "Kết thúc" }, {
                body: _withCtx((row) => [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.hour(row.data.lich.thoiGianKetThuc)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_Column, {
                field: "vaiTro",
                header: "Vai trò"
              }),
              _createVNode(_component_Column, {
                field: "lich.tenBenhNhan",
                header: "Người bệnh",
                style: {minWidth:'170px'}
              }),
              _createVNode(_component_Column, {
                field: "lich.maYTe",
                header: "Mã y tế"
              }),
              _createVNode(_component_Column, {
                field: "lich.tenDichVu",
                header: "Dịch vụ",
                style: {minWidth:'230px'}
              }),
              _createVNode(_component_Column, {
                field: "phoiHop",
                header: "Phối hợp cùng",
                style: {minWidth:'170px'}
              }),
              _createVNode(_component_Column, {
                field: "lich.tenThietBi",
                header: "Thiết bị",
                style: {minWidth:'150px'}
              })
            ]),
            _: 1
          }, 8, ["value"])
        ], 64))
  ]))
}